// apps/widget/src/components/product-card.tsx

import { formatCurrency, t } from '../lib/i18n';
import { send } from '../lib/postmessage';

export interface Product {
  id: string;
  name: string;
  routineSlot: string;
  price: number;
  currency: string;
  imageUrl?: string | null;
  externalUrl?: string | null;
  rationale?: string | null;
}

export function ProductCard({ product, step }: { product: Product; step: number }) {
  return (
    <article className="gs-product">
      <span className="gs-product-step" aria-hidden="true">
        {step}
      </span>

      {product.imageUrl ? (
        <img src={product.imageUrl} alt="" className="gs-product-image" loading="lazy" />
      ) : (
        // Clinics often have no product photography, and an empty box on every
        // row would dominate the screen. A soft placeholder reads as intentional.
        <div className="gs-product-image gs-product-image--placeholder" aria-hidden="true" />
      )}

      <div className="gs-product-body">
        <h3 className="gs-product-name">{product.name}</h3>
        {product.rationale && <p className="gs-product-why">{product.rationale}</p>}
        <span className="gs-product-price">{formatCurrency(product.price, product.currency)}</span>
      </div>

      {product.externalUrl && (
        <a
          className="gs-btn gs-btn--ghost gs-btn--sm"
          href={product.externalUrl}
          target="_blank"
          rel="noreferrer noopener"
          // Reported as a click, and labelled as one. Attribution past the click
          // needs a pixel on the clinic's confirmation page.
          onClick={() => send('gs:cta:clicked', { mode: 'product' })}
        >
          {t('routine.viewProduct')}
        </a>
      )}
    </article>
  );
}
